export default {
    HOME: 'home',
    AWAY: 'away'
};
